import { render, staticRenderFns } from "./viPrivacy.vue?vue&type=template&id=fcb86d80&scoped=true&"
import script from "./viPrivacy.vue?vue&type=script&lang=js&"
export * from "./viPrivacy.vue?vue&type=script&lang=js&"
import style0 from "./viPrivacy.vue?vue&type=style&index=0&id=fcb86d80&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcb86d80",
  null
  
)

export default component.exports